<template>
  <div class="parent image main">
    <img alt="Stream Cover" :src="stream.cover" />
    <RTAvatar class="avatar" v-if="stream.avatar" :size="size" :img="stream.avatar"/>
  </div>
</template>

<script>
import RTAvatar from '@/components/RTAvatar.vue'
export default {
  name: 'RTProjectCover',
  components:{
    RTAvatar
  },
  props:{
    stream:{
      type:Object
    },
    size:{
      type:String,
      default:"100px"
    }
  },
  watch:{
  },
  data: function() {
    return {
    };
  },
  computed:{

  },
  methods:{
   
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>
.parent{
  position: relative;
  top: 0;
  left: 0;
} 
.avatar{
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>